import { hasLocizeTranslation } from 'lib/utils/locize'

// Compact lower bounds, never rounded up. Missing sales are not zero sales.
export const formatSold = (count) => {
  if (!Number.isSafeInteger(count) || count <= 0) return null
  return count >= 1000 ? `${Math.floor(count / 1000)}k+` : String(count)
}

export const formatSoldLabel = (count, t, language = 'en') => {
  const sold = formatSold(count)
  if (!sold) return null
  const isThai = language.toLowerCase().split('-')[0] === 'th'
  const label = hasLocizeTranslation(
    t,
    'PDP_TRUST_SOLD',
    isThai ? 'ขายแล้ว' : 'sold',
  )
  return isThai ? `${label} ${sold}` : `${sold} ${label}`
}
